import React from 'react';
import styles from './Switch.module.css';

export default function Switch({ checked, onChange, label, id, disabled = false, className = '', ...rest }) {
  return (
    <label className={`${styles.switch} ${className}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={styles.input}
        id={id}
        {...rest}
      />
      <span className={styles.track}>
        <span className={styles.thumb} />
      </span>
      {label && <span className={styles.label}>{label}</span>}
    </label>
  );
}
